'use strict';

import axios from 'axios';
import { Loader } from '@googlemaps/js-api-loader';

const initGoogleMapsAutocomplete = async () => {
  const response = await axios.post(
    globalVariables.endpoint.getGoogleMapsAutocompleteData
  );

  if (response.status !== 200) {
    console.error('Error getting Google Maps Autocomplete data');
    return;
  }

  const { data } = response;
  const { apiKey = null, language = null, countryCode = '' } = data;

  if (!apiKey || !language) {
    console.error('Missing Google Maps Autocomplete data');
    return;
  }

  const loader = new Loader({
    apiKey: apiKey,
    version: 'weekly',
    libraries: ['places'],
    language: language
  });

  return {
    loader: loader,
    language: language,
    countryCode: countryCode
  };
};

export { initGoogleMapsAutocomplete };
